
  import { Vue, Component, Prop } from "vue-property-decorator";
  import Search from "@/components/common/SearchNew.vue";

  @Component({
    components: {
      Search,
    },
  })
  export default class SearchOnAction extends Vue {

    @Prop({type: String, default: ""}) nameSearchStyle: string;

    searchData: string = "";

    onSearch(): void {
      this.$emit("search", this.searchData);
    }

    onSearchUpdate(value: string): void {
      if (value.length === 0 && this.searchData.length !== 0) {
        this.searchData = "";
        this.onSearch();
      }

      this.searchData = value;
    }
  }
